import { useQueryClient } from 'react-query';
import {
  organizationSiteApiKeys,
  useOrganizationSiteApi,
} from '@hooks/api/useOrganizationSiteApi';
import { usePostApi } from '@hooks/api/usePostApi';
import type { ApiOptions } from 'types/api';
import type { OrganizationSiteProfileResponse } from 'types/organization-site';

export const usePublishSiteProfile = (
  organizationId: string,
  options: ApiOptions<OrganizationSiteProfileResponse> = {}
) => {
  const api = useOrganizationSiteApi();
  const queryClient = useQueryClient();

  const { isPosting, post, ...response } = usePostApi({
    ...options,
    getSuccessMessage: () => 'Site has been published',
    onSuccess: (data, ...args) => {
      queryClient.invalidateQueries(
        organizationSiteApiKeys.get(organizationId)
      );
      options?.onSuccess?.(data, ...args);
    },
    request: () => api.publish(organizationId),
  });

  return {
    ...response,
    isPublishingSiteProfile: isPosting,
    publishSiteProfile: post,
  };
};
